<template>
  <div>
    <section class="account-section padding-bottom padding-top">
      <div class="container">
        <div class="account-wrapper">
          <div class="left-side">
            <div class="section-header">
              <h2 class="title">Login</h2>
              <p>Escolha como deseja entrar em sua conta.</p>
            </div>
            <ul class="login-with">
              <li>
                <a href="#" @click="loginGoogleFacebook('Facebook')" class="facebook"><i
                    class="fab fa-facebook"></i>Entrar com Facebook</a>
              </li>
              <li>
                <a href="#" @click="loginGoogleFacebook('Google')" class="google"><i
                    class="fab fa-google-plus"></i>Entrar com Google</a>
              </li>
            </ul>
            <div class="or">
              <span>Ou</span>
            </div>
            <form class="login-form" @submit.prevent="logarUsuarioSenha">
              <div class="form-group mb-30">
                <label for="login-email"><i class="far fa-envelope"></i></label>
                <input type="text" id="login-email" placeholder="Email" v-model="nomeUsuario" />
              </div>
              <div class="form-group mb-30 password-group">
                <label for="login-senha"><i class="fas fa-lock"></i></label>
                <input :type="mostrarSenha ? 'text' : 'password'" id="login-senha" placeholder="Senha"
                  v-model="senha" />
                <i class="toggle-password" :class="mostrarSenha ? 'fas fa-eye-slash' : 'fas fa-eye'"
                  @click="mostrarSenha = !mostrarSenha"></i>
              </div>
              <div class="alert alert-danger" v-if="getMensagem">
                {{ getMensagem }}
              </div>
              <div class="alert alert-danger" v-if="getLoginError">
                {{ getLoginError }}
              </div>
              <div class="alert alert-danger" v-if="inativo">Conta desativada</div>
              <div class="form-group mb-5 d-flex justify-content-around">
                <a href="javascript:void()" @click="esqueceuSuaSenha()">Esqueceu sua senha?</a>
                <a href="javascript:void()" @click="reenviarConfirmacao()">Reenviar confirmação de email</a>
              </div>

              <div class="form-group mb-0">
                <button type="submit" class="custom-button login-button" :disabled="getLoginLoading">
                  <i class="fa fa-spin fa-spinner" v-if="getLoginLoading"></i>
                  Entrar
                </button>
              </div>

              <!--<div class="form-group mb-0 pt-3">
                <a href="javascript:void(0)" @click="logout" class="btn btn-link">Sair</a>
              </div>-->
            </form>
          </div>
          <div class="right-side cl-white">
            <div class="section-header mb-0">
              <h3 class="title mt-0">Novo por aqui?</h3>
              <p>Crie sua conta grátis</p>
              <a href="/cadastro" class="custom-button cadastre-button">Cadastre-se</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="showAuthenticatorModal" class="authenticator-modal">
      <div class="modal-backdrop"></div>
      <div class="authenticator-dialog" @click.stop @keydown.enter.prevent="submitMfa">
        <div class="alert alert-danger" v-if="mfaError">{{ mfaError }}</div>
        <template v-if="!useRecoveryCode">
          <h4>Autenticação de Dois Fatores</h4>
          <p>Insira o código do seu Autenticador (OTP)</p>
          <input ref="mfaCodeInput" type="text" v-model="mfaCode" placeholder="Código OTP" maxlength="7"
            autocomplete="one-time-code" inputmode="numeric" pattern="[0-9 ]*" :disabled="submittingMfa"
            @input="formatarMfaCode" />
          <div class="mfa-secondary-link">
            <a href="javascript:void(0)" @click.stop="toggleMfaMode(true)">
              Não tem o código OTP? Usar um código de segurança.
            </a>
          </div>
          <div class="mt-3">
            <button class="custom-button" @click.stop="submitMfa" :disabled="submittingMfa">
              <i class="fa fa-spin fa-spinner" v-if="submittingMfa"></i>
              Validar
            </button>
            <button class="btn btn-link" @click.stop="cancelMfa" :disabled="submittingMfa">Cancelar</button>
          </div>
        </template>
        <template v-else>
          <div class="recovery-header">
            <a href="javascript:void(0)" class="recovery-back-link" @click.stop="toggleMfaMode(false)"
              :disabled="submittingMfa">
              ← Voltar para o código OTP
            </a>
          </div>
          <h4 class="recovery-title">Código de Segurança</h4>
          <p class="recovery-description">
            Use um dos códigos de segurança gerados quando você ativou o 2FA. Cada código é de uso único.
          </p>
          <input ref="recoveryCodeInput" type="text" v-model="recoveryCode" placeholder="Digite um código de segurança"
            maxlength="20" autocomplete="off" class="recovery-input" :disabled="submittingMfa" />
          <small class="recovery-hint">
            Dica: códigos foram salvos no momento da ativação do 2FA. Exemplo: ABC1-DEF2-GHI3.
          </small>
          <div class="mt-3">
            <button class="custom-button" @click.stop="submitMfa" :disabled="submittingMfa">
              <i class="fa fa-spin fa-spinner" v-if="submittingMfa"></i>
              Validar
            </button>
            <button class="btn btn-link" @click.stop="cancelMfa" :disabled="submittingMfa">Cancelar</button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import notification from '@/mixins/notification';
import { ID_URL } from '../../config/config';
export default {
  data() {
    return {
      nomeUsuario: '',
      senha: '',
      mostrarSenha: false,
      provedor: '',
      inativo: false,
      showAuthenticatorModal: false,
      mfaCode: '',
      recoveryCode: '',
      useRecoveryCode: false,
      submittingMfa: false,
      mfaError: '',
      socialMfaPending: false,
      colorPrimary: process.env.VUE_APP_PRIMARY_COLOR,
      colorSecondary: process.env.VUE_APP_SECONDARY_COLOR,
      colorConstrast: process.env.VUE_APP_CONSTRAST_COLOR,
    };
  },
  mixins: [notification],
  computed: {
    ...mapGetters(['getMensagem', 'getLoginError', 'getLoginLoading', 'getAuth', 'getRegisterCompleted']),
  },
  methods: {
    ...mapActions([
      'setLoginGoogle',
      'setLoginFacebook',
      'setLogin',
      'setLoginWithPassword',
      'setLoginWithOtp',
      'logout',
      'checkRegisterCompleted',
      'validateMfaSocial',
    ]),
    async logarUsuarioSenha() {
      this.$store.commit('SET_LOGIN_ERROR', null);
      this.$store.commit('SET_MENSAGEM', null);

      const payload = {
        nomeUsuario: this.nomeUsuario,
        senha: this.senha,
        returnUrl: this.$route.query.returnUrl,
      };
      try {
        const resp = await this.setLoginWithPassword(payload);

        if (resp && resp.mfaRequired) {
          this.mfaCode = '';
          this.recoveryCode = '';
          this.useRecoveryCode = false;
          this.mfaError = '';
          this.showAuthenticatorModal = true;
          this.$nextTick(() => {
            var el = this.$refs.mfaCodeInput;
            if (el && el.focus) el.focus();
          });
          return;
        }

        const rc = await this.checkRegisterCompleted();

        if (!rc.ativo) {
          this.$store.commit('SET_AUTH');
          this.inativo = true;
        } else {
          this.$router.push(this.$route.query.returnUrl || { name: 'index' });
        }
      } catch (err) {
        // Se houver erro E não temos mensagem de erro já setada, mostra uma
        const erroExistente = this.getLoginError || this.getMensagem;
        if (!erroExistente) {
          this.$store.commit('SET_LOGIN_ERROR', 'Houve um problema ao carregar os dados do usuário após o login. Atualize a página ou tente novamente.');
        }
        return;
      }
    },

    cancelMfa() {
      this.showAuthenticatorModal = false;
      this.mfaCode = '';
      this.recoveryCode = '';
      this.useRecoveryCode = false;
      this.mfaError = '';
      this.socialMfaPending = false;
      this.$store.commit('SET_LOGIN_ERROR', null);
      this.$store.commit('SET_PENDING_SOCIAL_AUTH', null);
    },
    formatarMfaCode() {
      const apenasDigitos = String(this.mfaCode || '').replace(/\D/g, '').slice(0, 6);
      if (apenasDigitos.length <= 3) {
        this.mfaCode = apenasDigitos;
      } else {
        this.mfaCode = `${apenasDigitos.slice(0, 3)} ${apenasDigitos.slice(3)}`;
      }
    },
    toggleMfaMode(useRecovery) {
      this.useRecoveryCode = useRecovery;
      this.$store.commit('SET_LOGIN_ERROR', null);
      this.$nextTick(() => {
        var el = useRecovery ? this.$refs.recoveryCodeInput : this.$refs.mfaCodeInput;
        if (el && el.focus) el.focus();
      });
    },
    async submitMfa() {
      this.$store.commit('SET_LOGIN_ERROR', null);
      this.mfaError = '';
      this.submittingMfa = true;
      try {
        if (this.socialMfaPending) {
          if (this.useRecoveryCode) {
            this.mfaError = 'Códigos de segurança não são permitidos para login social. Use o código OTP do autenticador.';
            return;
          }
          const otpDigits = String(this.mfaCode || '').replace(/\D/g, '');
          if (!otpDigits || otpDigits.length !== 6) {
            this.mfaError = 'Informe o código de 6 dígitos.';
            return;
          }
          await this.validateMfaSocial({ code: otpDigits });
          this.$store.commit('COMMIT_SOCIAL_AUTH');
        } else {
          const payload = {
            nomeUsuario: this.nomeUsuario,
            senha: this.senha,
            otp: String(this.mfaCode || '').replace(/\D/g, ''),
            returnUrl: this.$route.query.returnUrl,
          };

          if (this.useRecoveryCode) {
            var rc = String(this.recoveryCode || '').trim().replace(/[\s-]/g, '');
            if (!rc || rc.length < 6) {
              this.mfaError = 'Informe um código de segurança válido (mínimo 6 caracteres).';
              return;
            }
            payload.recoveryCode = rc;
          }

          await this.setLoginWithOtp(payload);
        }

        this.showAuthenticatorModal = false;
        this.mfaCode = '';
        this.recoveryCode = '';
        this.useRecoveryCode = false;
        this.socialMfaPending = false;

        const rc2 = await this.checkRegisterCompleted();
        if (!rc2.ativo) {
          this.$store.commit('SET_AUTH');
          this.inativo = true;
        } else {
          this.$router.push(this.$route.query.returnUrl || { name: 'index' });
        }
      } catch (e) {
        this.mfaError = '';
        var errorCode = null;
        try {
          var r = (e && e.response && e.response.data) || {};
          errorCode = r.error_code || r.ErrorCode;
        } catch (_) { errorCode = null; }
        var msg = this.getLoginError || 'Não foi possível validar. Verifique e tente novamente.';
        if (errorCode === 'invalid_recovery_code') {
          msg = 'Este código de segurança é inválido ou já foi utilizado. Use outro código ou entre em contato com o suporte.';
        }
        this.mfaError = msg;
      } finally {
        this.submittingMfa = false;
      }
    },
    async loginGoogleFacebook(provider) {
      // mainOidc está configurado com SignInType.Popup: abre popup para Identity/Google/Facebook
      // e o vue-oidc-client resolve o callback e dispara addUserLoaded sem recarregar esta página.
      try {
        if (provider === 'Google') {
          await this.setLoginGoogle();
        } else if (provider === 'Facebook') {
          await this.setLoginFacebook();
        }

        const rc = await this.checkRegisterCompleted();
        // ativo=false com cadastroCompleto=false é cadastro pendente (não conta desativada);
        // nesse caso o router.beforeEach já redireciona para /cadastro.
        if (rc.cadastroCompleto && !rc.ativo) {
          this.inativo = true;
        } else if (rc.mfaRequired && !rc.mfaEnabled) {
          this.$store.commit('COMMIT_SOCIAL_AUTH');
          this.$router.push({ name: 'seguranca' });
        } else if (rc.mfaEnabled) {
          this.showAuthenticatorModal = true;
          this.socialMfaPending = true;
        } else {
          this.$store.commit('COMMIT_SOCIAL_AUTH');
          this.$router.push(this.$route.query.returnUrl || { name: 'index' });
        }
      } catch (err) {
        // Popup fechado/cancelado pelo usuário: não exibe erro
      }
    },

    esqueceuSuaSenha() {
      const url = ID_URL + 'identity/account/ForgotPassword';
      const newwindow = window.open(url, 'popup', 'width=450,height=480');
      if (window.focus) {
        newwindow.focus();
      }
      return false;
    },
    async reenviarConfirmacao() {
      this.$router.push({ name: 'reenviar-confirmacao-email' });
      return false;
    },
  },
  async created() {
    // if ("inativo" in this.$route.params) {
    //   this.inativo = true;
    // }
    this.$store.commit('SET_LOGIN_ERROR', null);
    this.$store.commit('SET_MENSAGEM', null);

    if ('emailConfirmado' in this.$route.query) {
      this.showAlert({
        type: 'success',
        title: 'Obrigado!',
        message: 'Seu email foi confirmado com sucesso, faça o login agora mesmo.',
      });
    }

    if (this.$route.query.cadastroConcluido === '1') {
      this.showAlert({
        type: 'info',
        title: 'Cadastro realizado!',
        message: 'Enviamos um link de confirmação para o seu e-mail. Acesse-o para ativar sua conta antes de fazer login.',
      });
    }
  },
};
</script>

<style scoped>
.password-group {
  position: relative;
}

.password-group .toggle-password {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
}

.account-wrapper .right-side,
.login-button {
  background-color: v-bind(colorPrimary) !important;
  color: v-bind(colorConstrast) !important;
  font-weight: 500 !important;
}

.cadastre-button {
  background-color: v-bind(colorConstrast);
  color: v-bind(colorPrimary);
}

@media (max-width: 576px) {
  .account-section {
    padding-top: 180px;
  }
}

.authenticator-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}

.authenticator-modal .modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  pointer-events: none;
  z-index: 0;
}

.authenticator-dialog {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 420px;
  margin: 16px;
  padding: 28px 24px 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  color: #222;
  pointer-events: auto;
  cursor: default;
}

.authenticator-dialog h4 {
  margin: 0 0 8px;
  font-size: 1.25rem;
  font-weight: 700;
  color: #171d1c;
}

.authenticator-dialog p {
  margin: 0 0 16px;
  color: #555;
  font-size: 0.7rem;
}

.authenticator-dialog input[type="text"] {
  width: 100%;
  padding: 12px 14px;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 6px;
  outline: none;
  letter-spacing: 2px;
  text-align: center;
  font-weight: 600;
}

.authenticator-dialog input[type="text"]:focus {
  border-color: #0783ae;
  box-shadow: 0 0 0 3px rgba(7, 131, 174, 0.15);
}

.authenticator-dialog input.recovery-input {
  letter-spacing: 1px;
  text-align: left;
  font-weight: 500;
  text-transform: uppercase;
  border-color: #cbd5e1;
  background: #f8fafc;
}

.authenticator-dialog input.recovery-input:focus {
  border-color: #475569;
  box-shadow: 0 0 0 3px rgba(71, 85, 105, 0.12);
  background: #fff;
}

.authenticator-dialog .recovery-hint {
  display: block;
  margin-top: 8px;
  color: #6b7280;
  font-size: 0.8rem;
  line-height: 1.35;
}

.authenticator-dialog .mfa-secondary-link {
  margin-top: 10px;
  text-align: left;

}

.authenticator-dialog .mfa-secondary-link a {
  color: #0783ae;
  font-size: 0.7rem;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
}

.authenticator-dialog .mfa-secondary-link a:hover {
  text-decoration: underline;
}

.authenticator-dialog .recovery-header {
  margin: -4px 0 10px;
}

.authenticator-dialog .recovery-back-link {
  color: #0783ae;
  font-size: 0.85rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
}

.authenticator-dialog .recovery-back-link:hover {
  text-decoration: underline;
}

.authenticator-dialog .recovery-title {
  color: #222;
}

.authenticator-dialog .recovery-description {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 0.85rem;
  color: #475569;
  line-height: 1.5;
  margin: 0 0 16px;
}

.authenticator-dialog .mt-3 {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: nowrap;
  width: 100%;
}

.authenticator-dialog .custom-button {
  flex: 1;
  max-width: 200px;
  margin: 0;
}

.authenticator-dialog .btn-link {
  flex: 1;
  background: transparent;
  border: none;
  color: #555;
  cursor: pointer;
  padding: 10px 12px;
  text-decoration: underline;
  text-align: center;
  white-space: nowrap;
  margin: 0;
}
</style>
